import React from 'react';
import { motion } from 'framer-motion';
import { FileSearch, Users, Pencil, Hammer, Eye, Key, Star } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import './ProcessTimeline.css';

const ProcessTimeline = () => {
  const { t } = useTranslation();

  const steps = [
    {
      icon: <FileSearch size={28} />,
      title: t('process.step1'),
      description: t('process.step1Desc')
    },
    {
      icon: <Users size={28} />,
      title: t('process.step2'),
      description: t('process.step2Desc')
    },
    {
      icon: <Pencil size={28} />,
      title: t('process.step3'),
      description: t('process.step3Desc')
    },
    {
      icon: <FileSearch size={28} />,
      title: t('process.step4'),
      description: t('process.step4Desc')
    },
    {
      icon: <Hammer size={28} />,
      title: t('process.step5'),
      description: t('process.step5Desc')
    },
    {
      icon: <Key size={28} />,
      title: t('process.step6'),
      description: t('process.step6Desc')
    }
  ];

  return (
    <section className="process-timeline-section">
      <div className="process-timeline-container">
        <motion.div 
          className="process-timeline-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="process-timeline-title">{t('process.title')}</h2>
          <p className="process-timeline-subtitle">
            {t('process.subtitle')}
          </p>
        </motion.div>

        <div className="timeline-horizontal-wrapper">
          <div className="timeline-horizontal-line"></div>
          
          <div className="timeline-steps-grid">
            {steps.map((step, index) => (
              <motion.div
                key={index}
                className="timeline-card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.08 }}
              >
                <div className="card-number">{index + 1}</div>
                <div className="card-icon-wrapper">
                  <div className="card-icon">{step.icon}</div>
                </div>
                <h3 className="card-title">{step.title}</h3>
                <p className="card-description">{step.description}</p>
                
                {index < steps.length - 1 && (
                  <div className="card-arrow">→</div>
                )}
              </motion.div>
            ))}
          </div>

          <motion.div 
            className="timeline-success-badge"
            initial={{ opacity: 0, scale: 0 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.6 }}
          >
            <Star size={24} />
            <span>{t('process.badge')}</span>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ProcessTimeline;
